'use client'

// Components
import { Button } from '@/components/ui'

// Icons
import { IconArrowLeft, IconError404 } from '@tabler/icons-react'

export default function NotFound() {
  const handleBack = () => {
    window.history.back()
  }

  return (
    <div className="flex justify-center items-center bg-background w-full h-screen">
      <div className="text-foreground text-center">
        <IconError404
          size={48}
          stroke={1}
          className="mx-auto mb-4"
        />

        <h1 className="mb-2 font-black text-2xl">We can&apos;t seem to find that page!</h1>
        <p className="mx-auto w-2/5 text-muted-foreground">
          The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
        </p>

        <div className="flex flex-col justify-center items-center gap-4 mt-12">
          <Button onClick={handleBack}>
            <IconArrowLeft />
            <span>Go back</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
